import React from 'react';
import { useLocation } from 'react-router';
import FormStructureEdit from './FormStructureEdit';
import FormStructureNew from './FormStructureNew';

const FormStructure = () => {
    const { state } = useLocation();
    return <>{state?.isNew ? <FormStructureNew /> : <FormStructureEdit />}</>;
};

export default FormStructure;
// export default WithPatientFileHeader(Form, ['sidebar', 'visit']);
